import React from "react";
import {Typography} from "@mui/material";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import Box from "@mui/material/Box";

const FavoriteWithCenteredNumber = ({
    count,
    isLiked,
    onClick,
}: {
    count: number;
    isLiked: boolean;
    onClick: (isChecked: boolean) => void
}) => {
    return (
        <Box position="relative" display="inline-flex" onClick={() => onClick(!isLiked)}>
            {isLiked ? (
                <>
                    <FavoriteIcon fontSize="large" color="error"/>
                    <Typography
                        variant="caption"
                        fontWeight="bold"
                        sx={{
                            position: "absolute",
                            top: "45%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            color: "white",
                            fontSize: "14px",
                            textAlign: "center",
                            userSelect: "none",
                        }}
                    >
                        {count}
                    </Typography>
                </>
            ) : (
                <FavoriteBorderIcon fontSize="large"/>
            )}
        </Box>
    );
};

export default FavoriteWithCenteredNumber;